import {
  getApiErrorMessage,
  isPaymentProviderRejectedError,
  isPaymentProviderUnavailableError,
} from '@massilia/queries'

export type CheckoutErrorType = 'error' | 'maintenance' | 'rejected'

/**
 * Classe l'échec du lancement de paiement. Le message affiché est celui de
 * l'API quand il existe : il est déjà rédigé pour le client (panne prestataire,
 * date d'acompte dépassée, mode de paiement basculé…).
 */
export function toCheckoutError(error: unknown): { message?: string; type: CheckoutErrorType } {
  const message = getApiErrorMessage(error)

  if (isPaymentProviderUnavailableError(error)) {
    return { message, type: 'maintenance' }
  }

  if (isPaymentProviderRejectedError(error)) {
    return { message, type: 'rejected' }
  }

  return { message, type: 'error' }
}
